import {TOCCHECKBOX} from './tocCheckBoxTypes'

export const changeCheckBox = checkBox => {
    return {
        type: TOCCHECKBOX,
        load: checkBox
    }
}

export const selectCheckBox = (checkBox) => {

    return (dispatch) => {
        dispatch(changeCheckBox(checkBox))
    }

}